module.exports = __webpack_public_path__ + "static/5-c692c72238c47ed5a37e85c9c597258a.jpg";